import { InputState, LABEL_TYPE } from '@kubit/web-ui-components/input/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { PopoverVariantType } from '../popover/variants';
import { InputVariantType } from '../variants';
import { InputDateVariantType } from './variants';
const COMMON_PROPS = (FOUNDATIONS, FONT) => ({
    inputVariant: InputVariantType.REGULAR,
    popoverVariant: {
        [DeviceBreakpointsType.DESKTOP]: PopoverVariantType.INPUT_DATE,
        [DeviceBreakpointsType.TABLET]: PopoverVariantType.INPUT_DATE,
        [DeviceBreakpointsType.MOBILE]: PopoverVariantType.INPUT_DATE,
    },
    label: {
        type: LABEL_TYPE.STANDARD,
    },
    inputIcon: {
        color: FOUNDATIONS.color_accent_default_secondary_icon_100,
    },
    titleAndAdditionalInfoContainer: {
        align_items: 'center',
    },
    popoverCloseButton: {
        display: 'flex',
        justify_content: 'flex-end',
    },
    popoverCalendarContainer: {
        padding_top: FOUNDATIONS.spacing_200,
        padding_left: FOUNDATIONS.spacing_250,
        padding_right: FOUNDATIONS.spacing_250,
    },
});
export const getInputDateStyles = (FOUNDATIONS, FONT) => ({
    [InputDateVariantType.DEFAULT]: {
        [InputState.EMPTY]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.ACTIVE]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.FILLED]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.ERROR_EMPTY]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.ERROR_FILLED]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.ERROR_ACTIVE]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.DISABLED_EMPTY]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.DISABLED_FILLED]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
        [InputState.DISABLED_FILLED_WITH_INFO]: {
            ...COMMON_PROPS(FOUNDATIONS, FONT),
        },
    },
});
//# sourceMappingURL=styles.js.map